import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-8">关于我们</h2>
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-gray-600 mb-6">
          是Top增加了一个o，为我们的客户成为Top企业赋能，增加浏览量（眼睛）和知名度，我们的公司就是帮所有企业的网页（主页、电子名片、扫码点单等）前置一个视频链接，提升视频浏览量，增加企业知名度和线上客源。
          </p>
        </div>
      </div>
    </section>
  );
};

export default About; 